import { useEffect, useRef } from 'react';
import { mountEmbeddedStripeCheckout } from '../lib/stripeCheckout.js';

/**
 * Overlay plein écran : monte Stripe Embedded Checkout dans `mountEl`.
 * Après paiement réussi, Stripe redirige vers `return_url` (même app, query success).
 */
export default function EmbeddedStripeCheckout({ clientSecret, onClose, onMountError }) {
  const mountRef = useRef(null);
  const destroyRef = useRef(null);
  const onErrRef = useRef(onMountError);
  onErrRef.current = onMountError;

  useEffect(() => {
    const el = mountRef.current;
    if (!el || !clientSecret) return undefined;

    let cancelled = false;
    (async () => {
      const res = await mountEmbeddedStripeCheckout(clientSecret, el);
      if (cancelled) {
        if (res.ok) res.destroy();
        return;
      }
      if (!res.ok) {
        onErrRef.current?.(res.message);
        return;
      }
      destroyRef.current = res.destroy;
    })();

    return () => {
      cancelled = true;
      destroyRef.current?.();
      destroyRef.current = null;
    };
  }, [clientSecret]);

  return (
    <div className="fixed inset-0 z-[2000] flex flex-col bg-black/90">
      <div className="flex items-center justify-between gap-2 border-b border-border px-4 py-3">
        <p className="text-sm font-semibold text-white">Paiement sécurisé</p>
        <button type="button" className="btn-ghost px-3 py-1.5 text-xs" onClick={onClose}>
          Fermer
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-3 sm:p-4">
        <div
          ref={mountRef}
          className="mx-auto min-h-[420px] w-full max-w-lg rounded-2xl border border-border bg-bg-card p-2 sm:p-4"
        />
      </div>
      <p className="px-4 pb-3 text-center text-[11px] text-white/45">
        Paiement géré par Stripe · tu restes sur cette app jusqu’à la confirmation
      </p>
    </div>
  );
}
